import { render, staticRenderFns } from "./AddressReportingFilter.vue?vue&type=template&id=4be4a546&scoped=true&lang=pug&"
import script from "./AddressReportingFilter.vue?vue&type=script&lang=ts&"
export * from "./AddressReportingFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4a546",
  null
  
)

export default component.exports